"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeALDR = function CategoryCodeALDR(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeALDR"), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M10.267,9.5l.591-.005,0,.593h-.591v.591l.589,0,0,.589-.592.006,0,.589,1.182-.007L11.452,8.9,10.27,8.91l0,.593Zm.9-2.488-.009,1.3.886-.005-.022,4.134-.89,0v.589h.589v.587l-1.776.01.006-.587.589-.008.007-.589-.889.005.025-4.134.886,0,.009-1.894Z"
  }), _react.default.createElement("path", {
    d: "M7.377,5.6l-.131-1.75H5.423L5.292,5.6A2.268,2.268,0,0,0,4.137,7.3v5.571a.8.8,0,0,0,.8.8h2.8a.8.8,0,0,0,.8-.8V7.3A2.271,2.271,0,0,0,7.377,5.6Zm-.969,4.5A1.368,1.368,0,1,1,7.775,8.728,1.367,1.367,0,0,1,6.408,10.1Z"
  }), _react.default.createElement("path", {
    d: "M7.155,2.628a.332.332,0,0,0-.331-.307H5.845a.332.332,0,0,0-.331.307l-.047.633H7.2Z"
  }))));
};

var _default = CategoryCodeALDR;
exports.default = _default;